let dataHandle = document.querySelectorAll('[data-title-handle]')
let megaImage = document.querySelectorAll('.open .mega-image')
let megaBlock = document.querySelectorAll('[data-block-handle]')
// $megaImageImage = $dropdownContainer.find('.site-nav__promo')

if(megaBlock[0]){
  megaBlock[0].style.display = "block"
}

dataHandle.forEach( function(data) {
    data.addEventListener("mouseover", function( event ) {
        var dataHandle = data.dataset.titleHandle

        megaBlock.forEach( function(block) {
            var blockHandle = block.dataset.blockHandle
            block.style.display = "none"

            if (dataHandle === blockHandle) {
                block.style.display = "block"
            }
        })
    })
})

function toggleSidebar () {
    var sidebar = document.querySelector('.sidebar-filter')
    var products = document.querySelector('#bc-sf-filter-products')
    var toggle = document.querySelector('.filter-toggle')
    var top = document.querySelector('.filter-items')

    if (sidebar) {
        if (sidebar.style.display == "none") {
            sidebar.style.display = "block"
            top.style.display = "none"
            products.className = "grid--uniform grid--uniform-row-gutters large-row three-quarters grid__item small-down--one-whole bc-sf-filter-grid-view-items"
            toggle.innerHtml = "Close Filters"
            toggle.classList.add('toggle-on')
    
        } else {
            sidebar.style.display = "none"
            top.style.display = "block"
            toggle.innerHtml = "Show Filters"
            products.className = "grid grid--uniform grid--uniform-row-gutters large-row"
            toggle.classList.remove('toggle-on')
        }
    }
}

toggleSidebar ()
